import React from 'react';
import ReactDOM from 'react-dom';
import HttpsRedirect from 'react-https-redirect';
import App from './app';

if('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
  .then((registration) => {
    // 업데이트 발견
    registration.addEventListener('updatefound', () => {
      // 설치 중인 새로운 서비스 워커
      const newServiceWorker = registration.installing;
      console.log("CHCARE : New update found!");

      // 새로운 서비스 워커
      newServiceWorker.addEventListener('statechange', (event) => {
        const state = event.target.state;
        console.log("CHCARE : ", state);
        if(state === 'installed') {
          console.log("앱을 재시작하면 업데이트가 적용됩니다!");
          // util.message('앱을 재시작하면 업데이트가 적용됩니다!');
        }
      });
    });
  });

  navigator.serviceWorker.register('./firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Registration successful, scope is:', registration.scope);
    })
    .catch(function(err) {
      console.log('Service worker registration failed, error:', err);
    });
}

ReactDOM.render(
  <React.StrictMode>
    <HttpsRedirect>
      <App />
    </HttpsRedirect>
  </React.StrictMode>,
  document.getElementById('root')
);

